import {forwardRef} from 'react'
import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getBuild, getTagsCount} from '../../../../selectors'
import type {NormalizedBuild} from '../../../../types'

import Build from './Build'
import type {OwnProps, StateProps} from './Build.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const build: Partial<NormalizedBuild> = getBuild(state, props.buildId) || {}
  return {
    state: build.state,
    composite: build.composite,
    buildTypeId: build.buildType,
    tagsNumber: getTagsCount(state, props.buildId),
    hasBranch: Boolean(build.branchName),
    approvalStatus: build.approvalInfo?.status,
  }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(forwardRef(Build))
